import { useState, useEffect, useCallback, useRef } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export default function FarmMessages() {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const endRef = useRef(null);

  const load = useCallback(() => api.get('/farm/messages').then((r) => setMessages(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const send = async () => { if (!text.trim()) return; try { await api.post('/farm/messages', { body: text }); setText(''); load(); } catch { toast.error('Could not send'); } };

  return (
    <div data-testid="farm-messages" className="max-w-3xl">
      <p className="font-manrope text-dark/60 mb-6">Secure messaging with the FarmBox team. Use it for availability, pickup changes, shortages, and pricing.</p>
      <div className="bg-white rounded-2xl border border-forest/10 flex flex-col h-[60vh]">
        <div className="flex-1 overflow-auto p-6 space-y-3">
          {messages.length === 0 ? <p className="font-manrope text-dark/50 text-center py-12">No messages yet. Say hello to FarmBox.</p> : messages.map((m) => (
            <div key={m.message_id} className={`max-w-[75%] p-3 rounded-2xl font-manrope text-sm ${m.sender_role === 'farm' ? 'ml-auto bg-forest text-cream' : 'bg-cream text-dark'}`} data-testid={`msg-${m.message_id}`}>
              <p>{m.body}</p><p className="text-[10px] opacity-60 mt-1">{m.sender_name} · {new Date(m.created_at).toLocaleString()}</p>
            </div>
          ))}
          <div ref={endRef} />
        </div>
        <div className="flex gap-2 p-4 border-t border-forest/10">
          <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && send()} placeholder="Type a message…" className="flex-1 bg-cream border border-forest/20 rounded-xl px-4 py-2.5 font-manrope" data-testid="farm-msg-input" />
          <button onClick={send} className="btn-primary py-2.5 px-5" data-testid="farm-msg-send"><Send className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
